import React from "react";
import Form from "./form";
import { getLocalizedString } from "@icarius-localization/strings";
import CommonPage from "@icarius-common/commonPage";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";

const FormContainer = (props) => {

  const { isLoading, data, alertType, handleClose } = props;

  const isEdit = Boolean(data);

  const goBackItem = () =>
  <CustomIconButton
    title={getLocalizedString("goBack")}
    onClick={() => handleClose(false)}
    type={"goBack"}
  />

  return (
    <CommonPage
      title={`${isEdit ? 'Editar' : 'Crear'} ${getLocalizedString("alertDefinition")} ${isEdit ? `- ${data.Nombre}` : ''}`}
      menuItems={[goBackItem]}
      isLoading={isLoading}
      isNotGridPage      
    >
      <Form
        data={data}
        alertType={alertType}
        handleClose={handleClose}
      />
    </CommonPage>
  )
}
export default FormContainer;
